module.exports = __webpack_public_path__ + "img/_homePad_logo_dark.02a4079f.svg";